import classNames from "classnames";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  SELECT_BLOCK_ONCLICK,
  UPDATE_BLOCK_DATA,
  ADD_BLOCK_TO_PAGE,
  TOGGEL_POPUP,
  UPDATE_SITE_SETTINGS,
  SELECT_ELEMENT,
  RESTYLE_BLOCK,
} from "../../../constants/action.constants";
import { set, cloneDeep, find, replace, findIndex } from "lodash";
import { INPUT_TEXT } from "../../../constants/var.constants";
import { twdClass } from "../../../constants/tailwind.constants";
import { getSheetInfo, getSheetColumns } from "../../../api/services";
import { processBracesValues } from "../../../utils/common.utils";
import { toast } from "react-toastify";
import {Button} from "../../ui/button_ui";
import Select from "react-select";
import { ConnectionPanel } from "../connections/ConnectionPanel";
import { ConnectDataSourceVs_play, DynamicPageVs_play} from "../../content/visual_steps";
import * as JSONS_CARDS from "../../../jsons_restyle/parts/cards";
import {GetColumnsData} from "../../cards/ConnectionData";


const addBlockParams = (text='', value='') => {
  
  text=JSON.parse(text)
  text.params = text.params ? text.params : []
  text.params = [...text.params, {value:value, label:value}]
  text=JSON.stringify(text)
  return text
}
const processText = (text, card_data) => {
  let textValue = text
  let values = processBracesValues(text);
  values.forEach((item) => {
    if(card_data[item.value]) {  
      console.log(item.value, card_data[item.value])     
      textValue = textValue.split(item.key).join(`[-[${card_data[item.value]}]-]`);
      //textValue = textValue.split(item.value).join(`${card_data[item.value]}`);
      textValue = addBlockParams(textValue, card_data[item.value])
      //console.log("ELEMENT_REPLACE", item.key, item.value, card_data[item.value])
    }
  });
  textValue=textValue.replaceAll( "[-[", "[[")
  textValue=textValue.replaceAll( "]-]", "]]");
  //console.log("text values", textValue, values, card_data)
  return textValue
}

const processObject = (element, card_data) => {
  let element_= processText(JSON.stringify(element), card_data)
  return JSON.parse(element_)
}

const processTable = (blockInfo, card_data) => {
  let bk = blockInfo.table_bk ? blockInfo.table_bk : blockInfo.table
  blockInfo.table_bk=bk
  blockInfo.table.columns=bk.columns.map((column)=>{
    column.elements=column.elements.map((element)=>{
      return processObject(element, card_data)
    })    
    return column
  })
  blockInfo.configs.previewWithTemplateData=true
  //console.log("blockInfo", bk, blockInfo)
  return blockInfo
}

const processCards = (blockInfo, card_data) => {
  let bk = blockInfo.cardElements_bk ? blockInfo.cardElements_bk : [...blockInfo.cardElements]
  let loc_bk = blockInfo.cardLocations_bk ? blockInfo.cardLocations_bk : [...blockInfo.cardLocations]
  blockInfo.cardElements_bk=bk
  blockInfo.cardLocations_bk=loc_bk  
  blockInfo.cardElements=bk.map((element)=>{    
    return processObject(element, card_data)
  })
  blockInfo.cardLocations= processObject(loc_bk, card_data)
  blockInfo.configs.previewWithTemplateData=true
  return blockInfo
}




const MapColumns = ({blockInfo={}, replaceBlock, connection, forSidebar=false}) => {
  const [connectionType, setConnectionType] = useState("");
  const [columnNames, setColumnNames] = useState([]);
  const [optionsList, setOptionsList] = useState([]);
  const [mappedNames, setMappedNames] = useState([]);

  const {configs={}}=blockInfo

  const updateElementValue = (key, value) => {
    //console.log("up", key, value)   
  };

  const updateMap = (key, value) => {
    setMappedNames(prev=>{
      console.log(prev, key, value)
      let next=[...prev]
      next=next.map((item)=>{
        if(item.value==key) item.mapped=value
        return item        
      })
      return next
    })    
  };

  
  //console.log("columnNames", columnNames)

  useEffect(() => {
    setConnectionType(connection.sheetName!='' ? 'googleSheet' : 'supabase' );
    let templateParams = processBracesValues(JSON.stringify(blockInfo))
    setMappedNames(templateParams)
    //console.log("templateParams", templateParams)
  }, [connection.sheetName]);
  
  useEffect(() => {
    const oL = columnNames.map((itm) => ({
      value: itm.key,
      label: itm.value,
    }));
    setOptionsList(oL)
    //console.log("columnNames",connection, columnNames, oL)
  }, [columnNames]);

  if(!connection.sheetName && !connection.connectionTable) return <></>

  const updateTemplate= () => {
    let card_data={}, blockInfo_={}
    mappedNames.map(({value, mapped})=>{
      card_data[value] = mapped
    })
    if(configs.type == 'table'){
      blockInfo_= processTable({...blockInfo}, card_data)
    }else{
      blockInfo_= processCards({...blockInfo}, card_data)
    }
    //console.log("mapped Card Data", mappedNames, card_data, blockInfo_)
    blockInfo_.configs.connection.timestamp= new Date().getTime();
    //console.log("card_data", card_data, blockInfo_)
    //console.log("BI", blockInfo, blockInfo_)
    replaceBlock(blockInfo_)
  }

  const confirmChanges=()=>{
    if(configs.type == 'table'){
      delete blockInfo.table_bk
    }else{
      delete blockInfo.cardElements_bk
      delete blockInfo.cardLocations_bk
    }    
    blockInfo.configs.useDummyDataSource=false
    blockInfo.configs.previewWithTemplateData=false
    blockInfo.configs.connection.timestamp= new Date().getTime();
    replaceBlock(blockInfo)
  }
  const mapField = ({value}) => {
    //console.log("optionsList", optionsList)
    const found = find(mappedNames, [
      "value",
      value,
    ]);
    return (
      <div className={twdClass("flex flex-row items-center hover:bg-blue-500 hover:bg-opacity-10 px-2 py-1 rounded-md w-full")}>
        <div className={twdClass(`${forSidebar ? 'w-4/12' : 'w-6/12 py-1 '} px-2 `)}>          
          {value}
        </div>
        <div className={twdClass(`${forSidebar ? 'w-8/12' : 'w-6/12 py-1'} px-2 `)}>
          
          <select
            value={found.mapped}
            className={twdClass('INPUT_TEXT px-2 py-2 rounded-lg w-full')}
            onChange={(e) => {               
              updateMap(value, e.target.value);
            }}
            
          >             
            <option value="">Select</option>
            {columnNames.map((itm, index)=>{
              return(<option key={index} value={itm.key}>{itm.value}</option>)
            })}        
          </select>
        </div>
      </div>
    )
  }
  return (
    <div className={twdClass(`pb-12 ${forSidebar ? 'text-sm' : 'text-base px-12'} z-10 pt-1 relative mx-auto w-full `)} style={{maxWidth:'800px'}}>
      <GetColumnsData {...{ connection, connectionType, setColumnNames, updateElementValue}}/>
      <div className={twdClass(`${forSidebar ? 'p-2' : 'p-4'} bg-blue-100 rounded-xl`)}>
        <div className={twdClass("flex flex-row border-b border-blue-400 pb-2 mb-2")}>
          <div  className={twdClass(`${forSidebar ? 'w-4/12' : 'w-6/12'} px-2 `)}>Template Variables</div>
          <div  className={twdClass(`${forSidebar ? 'w-8/12' : 'w-6/12'} px-2 `)}>Data Source Variables</div>
        </div>
        {mappedNames.map((item, index)=>{
          return(
            <div key={index}>{mapField(item)}</div>
          )
        })}  
      </div>
      <div className={twdClass("flex items-center justify-center gap-4 mt-8")}>
        <Button
            type="default"  color="white" className={"inline-block"}   
            onClick={updateTemplate}
          >
          Preview 
        </Button>   
        <Button
            type="default"  color="black" className={"inline-block"}   
            onClick={confirmChanges}
          >
          Confirm
        </Button>     
      </div>
    </div>
  )
}
export {MapColumns} 